import '/app/brewery-packages/content/content-editor-plugin-unordered-list/src/UnorderedList.css-raw';
export default {
  "unorderedList": "jobs-2ec46bc8-unorderedList-wCRGkq"
};